import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
import(/* webpackMode: "eager" */ "/app/src/components/breadcrumbs/breadcrumbs.tsx");
import(/* webpackMode: "eager" */ "/app/src/components/locations/locations.module.scss")